module.exports = __webpack_public_path__ + "static/media/icon_alert.a19ea6a6.png";